import { ro } from './lib/resize_observer';

export default {
  sizeObserve (config) {
    const wurldRo = config && config.sizeObserve ? ro(config.sizeObserve) : ro();
    return {
      bind(el, binding) {
        if (binding.value) {
          el.setAttribute('data-wurldsobps', JSON.stringify(binding.value));
        }
        if (binding.modifiers.height) {
          el.setAttribute('data-wurldsoheight', true);
        }
        if (binding.modifiers.top) {
          el.setAttribute('data-wurldsotop', true);
        }
        if (binding.modifiers.left) {
          el.setAttribute('data-wurldsoleft', true);
        }
        wurldRo.observe(el);
      },
      unbind(el) {
        wurldRo.disconnect(el);
      }
    };
  }
};